'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

exports.default = function (name) {
  var additionalLogData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _finalCleanup = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (it) {
    return it;
  };

  var performanceApi = arguments[3];
  var beaconApi = arguments[4];
  return new Logger(name, additionalLogData, _finalCleanup, performanceApi || fetchPerformanceApi(), beaconApi);
};

var _xhr = require('xhr');

var _xhr2 = _interopRequireDefault(_xhr);

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

var _v = require('uuid/v4');

var _v2 = _interopRequireDefault(_v);

var _asyncMetric = require('./async-metric.js');

var _asyncMetric2 = _interopRequireDefault(_asyncMetric);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var logSession = (0, _v2.default)();

var Logger = function () {
  function Logger(name, additionalLogData, _finalCleanup, performanceApi, beaconApi) {
    _classCallCheck(this, Logger);

    this.xhr = _xhr2.default;
    this.name = name;
    this.additionalLogData = additionalLogData;
    this._finalCleanup = _finalCleanup;
    this.performanceApi = performanceApi;
    this.beaconApi = beaconApi;
    if (!this.additionalLogData.logSession) this.additionalLogData.logSession = logSession;
    this.resource = this.additionalLogData.resource || '/application/log.gif';
  }

  _createClass(Logger, [{
    key: 'debug',
    value: function debug(message) {
      var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._log('DEBUG', true, message, fields, Date.now());
    }
  }, {
    key: 'info',
    value: function info(message) {
      var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._log('INFO', true, message, fields, Date.now());
    }
  }, {
    key: 'warn',
    value: function warn(message) {
      var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._log('WARN', true, message, fields, Date.now());
    }
  }, {
    key: 'error',
    value: function error(message) {
      var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._log('ERROR', false, message, fields, Date.now());
    }
  }, {
    key: 'metric',
    value: function metric(message) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var fields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this._log('METRIC', true, message, _extends({}, fields, {
        duration: duration
      }), Date.now());
    }
  }, {
    key: 'asyncMetric',
    value: function asyncMetric(message, url) {
      return new _asyncMetric2.default(this, message, url, this.performanceApi);
    }
  }, {
    key: '_log',
    value: function _log(level, success, message, fields, timestamp) {
      var data = _extends({
        name: this.name,
        level: level,
        message: message,
        success: success,
        msg: message,
        timestamp: timestamp
      }, this.additionalLogData, fields);

      data = this._cleanupData(data);
      data = this._finalCleanup(data);
      return this._request(_qs2.default.stringify(data));
    }
  }, {
    key: '_cleanupData',
    value: function _cleanupData(data) {
      var output = {};

      for (var key in data) {
        if (!data.hasOwnProperty(key)) continue;
        var value = data[key];
        var derivedValue = typeof value === 'function' ? value() : value;

        if (derivedValue != null) {
          output[key] = ('' + derivedValue).substring(0, 1000);
        }
      }

      return output;
    }
  }, {
    key: '_request',
    value: function _request(queryParams) {
      var url = this.resource + '?' + queryParams;

      if (this.beaconApi) {
        this.beaconApi.sendBeacon(url);
        return;
      }

      if (this.xhr.ajax != null) {
        var jqxhr = this.xhr.ajax({
          method: 'GET',
          url: url
        });
        return jqxhr.fail(function () {
          console.log('Unable to log message: ' + url);
        });
      } else {
        return this.xhr({
          method: 'GET',
          uri: url
        }, function (error) {
          if (error) {
            return console.log('Unable to log message: ' + url);
          }
        });
      }
    }
  }]);

  return Logger;
}();

;

var fetchPerformanceApi = function fetchPerformanceApi() {
  try {
    var isNode = Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
    if (isNode) return undefined; // we want a non-namespaced, fully finished performance API only

    return window.performance;
  } catch (error) {
    return undefined;
  }
};